import React, { useCallback } from 'react';

import { Flex, Image, VStack } from '@chakra-ui/react';
import { updateOKR } from 'components/RabbitOKRCreationPanel/OKRCreationPanelSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { okrCreationPanelStateSelector } from 'selectors/okrCreationPanelSelector';
import { themeColors } from 'themes/clients/baseTheme';

import { Plus } from 'assets/assetsV1/iconComponents';
import NO_TAG_IMAGE from 'assets/assetsV1/images/notagIcon.svg';

import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium, TextHeader2, TextLabel } from 'uiToolkitV1/Typography';

import { useUpdateCustomTagsMutation } from '../datahooks/useGetCustomTagsOrganization';

interface Props {
  onClose: () => void;
  okrId: string;
  onSave: (newTag: { uuid: string; tagName: string }) => void;
  searchText?: string;
  newTagError?: string;
  showCreationScreen?: boolean;
}

const CreateNewTag = ({ okrId, onClose, onSave, searchText, newTagError, showCreationScreen }: Props) => {
  const dispatch = useDispatch();
  const { tagKeyList = [] } = useSelector(okrCreationPanelStateSelector);

  const onChange = useCallback(
    (updates) => {
      dispatch(updateOKR(updates));
    },
    [dispatch]
  );

  const { mutateAsync: addOrganizationLevelTag } = useUpdateCustomTagsMutation(() => {
    // onSave();
    // resetTagAdditionInterface(okrId);
  });

  const handTagAddition = async () => {
    const newTag = { tagName: searchText };
    if (newTagError) {
      return;
    }
    try {
      // @ts-ignore
      const res = await addOrganizationLevelTag({ tagDetails: newTag });
      const createdTag = res?.entity;
      const appendedTagKeyList = createdTag ? [...tagKeyList, createdTag] : [];
      // onChange({ tagKeyList: appendedTagKeyList });
      onSave(createdTag);
    } catch (error) {
      console.error('Error creating the tag : ', error);
    }
  };

  if (!showCreationScreen) {
    return null;
  }

  return (
    <VStack direction="column" align="center" spacing="10px" minH="274px" padding="32px 0 16px 0">
      <Flex>
        <Image
          // @ts-ignore
          src={NO_TAG_IMAGE}
          width="48px"
          height="80px"
        />
      </Flex>
      <Flex>
        <TextHeader2 bold>No tags to show</TextHeader2>
      </Flex>
      <Flex>
        <TextBodyMedium>
          Add "<b>{searchText}</b>" as a tag
        </TextBodyMedium>
      </Flex>
      {newTagError && (
        <Flex ml="12px" mt="-12px">
          <TextLabel color={themeColors.alerts.negative} bold>
            {newTagError}
          </TextLabel>
        </Flex>
      )}
      <Flex>
        <Button
          variant="outlined"
          StartIcon={Plus}
          color="blue"
          onClick={() => {
            // onClose();
            handTagAddition();
          }}
          disabled={newTagError !== ''}
        >
          Add tag
        </Button>
      </Flex>
    </VStack>
  );
};

export { CreateNewTag };
